













import { Component, Prop } from "vue-property-decorator";
import { BaseControl }from "@share/common/controls/base/base-control";

@Component({
    directives: {
        indeterminate: function(el: any, binding) {
            el.indeterminate = Boolean(binding.value);
        }
    }
})

export default class CheckboxControl extends BaseControl {
    @Prop({ default: false }) indeterminate: boolean;
    @Prop() checked: boolean;

    check: boolean;
}

